import { createSlice } from "@reduxjs/toolkit";

export const alertSlice = createSlice({
  name: "alert",
  initialState: {
    value: {
      view: false,
      title: "",
      caption: "",
      type: "",
    },
  },

  reducers: {
    closeAlert: (state) => {
      state.value.view = false;
      state.value.title = "";
      state.value.caption = "";
      state.value.type = "";
    },

    openAlert: (state, action) => {
      const alertProps = action.payload;
      state.value.view = true;
      state.value.title = alertProps.title;
      state.value.caption = alertProps.caption;
      state.value.type = alertProps.type;
    },
  },
});

export const { closeAlert, openAlert } = alertSlice.actions;

export default alertSlice.reducer;
